<template>
  <div class="menu">
    <img @click="toggleMenu" class="burger" src="@/assets/burger.svg" />
    <ul class="menu__list" :class="{ menu__list_expanded: isMenuShown }">
      <li class="menu__item">
        <router-link @click.native="hideMenu" class="pro" to="/my/faq">
          <span v-if="BRAND_KEY === 'appdb'" class="pro__start">db</span>
          <span v-else-if="BRAND_KEY === 'AppAddict'" class="pro__start">
            <img height="12px" :src="require(`@/assets/themes/${BRAND_KEY}/images/logo-${theme}.svg`)" />
          </span>
          <span class="pro__end">FAQ</span>
        </router-link>
      </li>
      <li class="menu__item">
        <router-link @click.native="hideMenu" class="pro" to="/my/premium">
          <span class="pro__end" style="width: 75px;">PREMIUM</span>
        </router-link>
      </li>
      <li class="menu__item">
        <router-link @click.native="hideMenu" class="link" to="/news">
          <img class="link__icon link__icon_small" src="@/assets/icon-news.svg" />{{ $t('NEWS') }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      isMenuShown: false,
    };
  },
  computed: {
    ...mapState(['theme']),
  },
  methods: {
    toggleMenu(e) {
      if (e.path.some(el => typeof el.className === 'string' && el.className.split(' ').includes('menu__list'))) {
        return;
      }
      this.isMenuShown = !this.isMenuShown;
    },
    hideMenu() {
      this.isMenuShown = false;
    },
    handleMenu(e) {
      if (e.path.some(el => typeof el.className === 'string' && el.className.split(' ').includes('menu'))) {
        return;
      }
      this.isMenuShown = false;
    },
  },
  mounted() {
    document.body.addEventListener('click', this.handleMenu);
  },
  destroyed() {
    document.body.removeEventListener('click', this.handleMenu);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.burger {
  display: none;

  @include notebook {
    display: block;
    height: 20px;
    opacity: 0.7;
    margin-top: 1px;
    filter: var(--img-filter);
  }
}

.menu {
  position: relative;

  @include notebook {
    margin-left: 0;
  }

  &__list {
    display: flex;

    @include notebook {
      display: none;
      position: absolute;
      right: -10px;
      top: 28px;
      flex-direction: column;
      z-index: 7;
      border-radius: 4px;
      background-color: var(--bg);
      box-shadow: 0 2px 8px 0 var(--shadow-color);
      padding: 5px 0;
    }

    &_expanded {
      @include notebook {
        display: flex;
      }
    }
  }

  &__item {
    margin-right: 40px;
    display: flex;
    align-items: center;

    &:first-child {
      margin-right: 20px;

      @include notebook {
        margin-right: 0;
      }

      @include notebook {
        order: 1;
      }
    }

    @include notebook {
      margin-right: 0;
    }

    &:nth-child(2) {
      @include notebook {
        order: 1;
      }
    }
  }
}

.pro {
  display: inline-block;
  border: 1px solid $primary;
  border-radius: 1px;
  line-height: 18px;
  text-align: center;

  @include notebook {
    display: flex;
    margin: 8px 20px;
  }

  &__start,
  &__end {
    float: left;
  }

  &__end {
    width: 40px;
  }

  &__start {
    width: 33px;
    color: var(--text-tertiary);
    font-weight: 600;

    img {
      position: relative;
      top: 1px;
    }
  }

  &__end {
    color: #fff;
    background-color: $primary;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
  }
}

.link {
  color: var(--text-primary);
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;

  @include notebook {
    padding: 8px 20px;
  }

  &__icon {
    position: relative;
    top: 2px;
    margin-right: 5px;

    &_small {
      top: 0;
    }
  }
}
</style>
